import React, { memo } from 'react'

import {
  Button, Icon, Slider, Undo, Redo, Eraser, Brush,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number } from 'prop-types'

import { iconSize, BRUSH } from 'Pods/ThreeDStudio/constants'

const undoIcon = <Icon svgComponent={Undo} size={iconSize} color="dark" notSpaced />
const redoIcon = <Icon svgComponent={Redo} size={iconSize} color="dark" notSpaced />
const eraserIcon = <Icon svgComponent={Eraser} size={iconSize} color="dark" notSpaced />
const brushIcon = <Icon svgComponent={Brush} size={iconSize} color="dark" notSpaced />

// Drawing tools for the Edit canvas, rendered into the composer's action row. Eraser
// and brush are a segmented pair rather than one toggle: each selects its own mode, so
// clicking the mode already in use is a no-op instead of flipping to the other tool.
function Toolbar({
  canUndo,
  canRedo,
  isErasing,
  brushSize,
  isSending,
  onUndo,
  onRedo,
  onErasingChange,
  onBrushSizeChange,
}) {
  const handleSelectEraser = () => onErasingChange(true)
  const handleSelectBrush = () => onErasingChange(false)

  return (
    <div className="image-assistant-edit-tab__tools">
      <Button
        variant="only-icon"
        type="secondary"
        size="small"
        actionType="button"
        customClass="image-assistant-edit-tab__tool"
        icon={undoIcon}
        aria-label="Undo"
        disabled={!canUndo || isSending}
        onClick={onUndo}
      />
      <Button
        variant="only-icon"
        type="secondary"
        size="small"
        actionType="button"
        customClass="image-assistant-edit-tab__tool"
        icon={redoIcon}
        aria-label="Redo"
        disabled={!canRedo || isSending}
        onClick={onRedo}
      />
      <div className="image-assistant-edit-tab__brush">
        <Button
          variant="only-icon"
          type="secondary"
          size="small"
          actionType="button"
          customClass="image-assistant-edit-tab__mode"
          icon={eraserIcon}
          aria-label="Eraser"
          aria-pressed={isErasing}
          disabled={isSending}
          onClick={handleSelectEraser}
        />
        <Button
          variant="only-icon"
          type="secondary"
          size="small"
          actionType="button"
          customClass="image-assistant-edit-tab__mode"
          icon={brushIcon}
          aria-label="Brush"
          aria-pressed={!isErasing}
          disabled={isSending}
          onClick={handleSelectBrush}
        />
        <Slider
          hideRangeValues
          min={BRUSH.MIN}
          max={BRUSH.MAX}
          step={BRUSH.STEP}
          value={brushSize}
          onChange={onBrushSizeChange}
          isDisabled={isSending}
          wrapperClassName="image-assistant-edit-tab__brush-slider"
        />
      </div>
    </div>
  )
}

Toolbar.propTypes = {
  canUndo: bool.isRequired,
  canRedo: bool.isRequired,
  isErasing: bool.isRequired,
  brushSize: number.isRequired,
  isSending: bool.isRequired,
  onUndo: func.isRequired,
  onRedo: func.isRequired,
  onErasingChange: func.isRequired,
  onBrushSizeChange: func.isRequired,
}

export default memo(Toolbar)
